import { TokenWithUserAndKey } from "src/clients/taktile-api";
import { useAuthStore } from "src/store/AuthStore";

/**
 * The session refresh every proactive near-expiry caller shares.
 *
 * Module-level so callers in different modules (the axios request middleware,
 * the API docs request interceptor) join the same mint instead of each firing
 * its own `POST /login/refresh`. Overlapping mints leave the last response to
 * win in token storage, and the losers' tokens are written and then discarded.
 *
 * Deliberately unscoped and argument-free: scoped mints (boot, workspace and
 * role switches) must not be coalesced with an unrelated caller's refresh.
 */
let refreshInFlight: Promise<TokenWithUserAndKey | void> | null = null;

export const refreshSession = (): Promise<TokenWithUserAndKey | void> => {
  if (refreshInFlight === null) {
    refreshInFlight = useAuthStore
      .getState()
      .actions.refresh()
      .finally(() => {
        refreshInFlight = null;
      });
  }
  return refreshInFlight;
};
